import { defineAction } from '~/prix'
import { z } from 'zod'
import ruralPropertyActivityUpdateAction from './ruralPropertyActivityUpdate.action.json' with { type: 'json' }
import { ruralPropertyActivityUpsertInputObject } from '../ruralPropertyActivityObject'

const ruralPropertyActivityUpdateDefinition = defineAction({
  ...ruralPropertyActivityUpdateAction,
  input: ruralPropertyActivityUpsertInputObject.extend({
    id: z.string().uuid(),
  }),
  output: z.object({}),
})

export default ruralPropertyActivityUpdateDefinition
